import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import GameBoard from '../components/GameBoard';
import { levels } from '../levels';
import { getGameProgress, saveGameProgress } from '../utils/storage';
import { Howl } from 'howler';

const winSound = new Howl({ src: ['/sounds/win.mp3'] });

const GamePage = () => {
  const { levelId } = useParams();
  const navigate = useNavigate();
  const level = levels.find(l => l.id === parseInt(levelId));
  const [gameOver, setGameOver] = useState(false);
  const [score, setScore] = useState(0);
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    const fetchProgress = async () => {
      const gameProgress = await getGameProgress();
      setProgress(gameProgress);
    };
    fetchProgress();
  }, []);

  const handleWin = async () => {
    if (!progress) return;
    const newProgress = { ...progress };
    if (!newProgress.completedLevels.includes(level.id)) {
      newProgress.completedLevels.push(level.id);
      newProgress.bricks += 1;
      await saveGameProgress(newProgress);
      setProgress(newProgress);
    }
    winSound.play();
    setGameOver(true);
  };

  const handleLose = () => {
    setGameOver(true);
  };

  const handleScoreUpdate = (newScore) => {
    setScore(newScore);
  };

  if (!level) return <div>Level not found</div>;
  if (!progress) return <div>Loading...</div>;

  return (
    <div>
      <h1>Level {level.id}</h1>
      {gameOver ? (
        <div>
          <p>{score >= level.targetScore ? 'You Won!' : 'Game Over'}</p>
          <button onClick={() => navigate('/levels')}>Back to Levels</button>
          <button onClick={() => navigate('/house')}>Build House</button>
        </div>
      ) : (
        <GameBoard
          level={level}
          onWin={handleWin}
          onLose={handleLose}
          onScoreUpdate={handleScoreUpdate}
        />
      )}
    </div>
  );
};

export default GamePage;